export const UPDATE_SERVICE = 'UPDATE_SERVICE';
export const RESET_SERVICE = 'RESET_SERVICE';